import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
// var ColorThief = require('color-thief');
// import VueHtmlToPaper from 'vue-html-to-paper';

Vue.config.productionTip = false

// const options = {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes'
//   ],
//   styles: [
//     'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons',
//     'https://unpkg.com/ionicons@4.4.2/dist/css/ionicons.min.css',
//     'https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css',
//   ]
// }

// Vue.use(VueHtmlToPaper, options);
var mixin = {
  methods: {
    // getImgColor: function (sourceImage) {
    //   var colorThief = new ColorThief();
    //   return colorThief.getColor(sourceImage);
    // }
  }
}

new Vue({
  router,
  store,
  i18n,
  mixins: [mixin],
  render: h => h(App)
}).$mount('#app')
